export const changePassword = {
  changeCurrentPassword: "当前密码",
  changeNewPassword: "新密码",
  changeConfirmNewPassword: "确认新密码",
  changePasswordMessage: "请输入您的密码!",
  changePasswordError: "密码不匹配!",
  changePasswordBtn: "提交",
};
